import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Select from 'react-select'
import { envAwarePost, capitalize } from '../../util/util'
import Form from "react-bootstrap/Form"
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import Spinner from "react-bootstrap/Spinner"
import moment from 'moment'
import { Link, useHistory } from 'react-router-dom';

import {
    updateCopy,
    addEventForCopying,
    copyAndEdit,
} from '../../state/events'
import { getEventList } from "../eventsView/eventsViewSlice"


function FavoritesModal(
    {
        addFavoriteEvent,
        setAddFavoriteEvent,
        favEventTypeChosen,
        setFavEventTypeChosen,
        selectedClient,
        // if true then can choose to view nutrition/workout/task all from same modal
        allEventTypeOptions,
        // what page will copyEdit process return to after complete
        origin,

    }) {

    let dispatch = useDispatch();
    let history = useHistory();

    /* --- State --- */

    const [chosenEventList, setChosenEventList] = useState([]);
    const [loadingFavoriteEvents, setLoadingFavoriteEvents] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [addLoaderById, setAddLoaderById] = useState("");

    // change color dependent on event type
    const eventColor =  //workout
        favEventTypeChosen === "workout" ? "rgb(0 157 183)"
            //task
            : favEventTypeChosen === "task" ? "rgb(0 197 79)"
                //nutrition
                : "rgb(233 162 44)";



    /* --- useEffects --- */

    useEffect(() => {
        if (addFavoriteEvent) {
            setLoadingFavoriteEvents(true);
            // dispatch api call to get all nutrition, tasks or workouts. 
            dispatch(getEventList({ event_type: favEventTypeChosen, filter: "favorite" }))
                .then(res => {
                    if (res.payload.success == "1") {
                        setChosenEventList(res.payload.data.events)
                        setLoadingFavoriteEvents(false);
                    }
                })
        }
    }, [favEventTypeChosen, addFavoriteEvent])

    // filter based off search query
    function handleFilter(event) {
        if (searchQuery) {
            let cleanedQuery = searchQuery.toLowerCase().trim();
            if (event.note.toLowerCase().includes(cleanedQuery)) {
                return true;
            }
        } else {
            return true;
        }
    }

    /* --- Handlers --- */

    // dispatch CopyEdit Api Call on Add Button Press
    function handleAddFavEvent(type, event_id, selectedClient) {
        setAddLoaderById(event_id)
        let todaysDate = moment(new Date()).format("YYYY-MM-DD")
        dispatch(copyAndEdit({
            event_id: event_id,
            event_type: favEventTypeChosen,
            tgt_client_id: selectedClient,
            start_date: todaysDate,
            end_date: todaysDate
        })).then(action => {
            const { data: newEvent } = action.payload
            setAddLoaderById("")
            let originSource = origin ? `origin=${origin}` : ""
            history.push(`/eventEditor/?event_id=${newEvent[`${type}_id`]}&event_type=AddOrEdit&eventType=${type}&client=${selectedClient}&${originSource}`)
        })
    }

    /* --- Render --- */

    // render Favorite Event (can be workout or task or nutrition)
    function renderFavEvent(event, type) {
        let event_id = event[type + "_id"]
        return (
            <div key={event_id?.toString()}  >
                {event.title ? <div className="mt-2">
                    {event.title}
                    <div style={{ float: "right" }} className="">
                        {addLoaderById === event_id ? <Spinner animation="border" variant="primary" />
                            : <Button
                                size="sm"
                                onClick={
                                    (e) => {
                                        handleAddFavEvent(type, event_id, selectedClient)
                                    }}
                            > Add </Button>}
                    </div>
                </div> : null}

                <hr />
            </div>
        )
    }

    return (
        <Modal closeButton show={addFavoriteEvent} onHide={() => { setAddFavoriteEvent(false); setSearchQuery("") }}>
            <Modal.Header closeButton>
                <Modal.Title className="p-2"> Add Favorite Event </Modal.Title>
            </Modal.Header>
            <hr style={{ width: '100%', margin: '0px' }} />
            <Modal.Body style={{ maxHeight: "600px", overflow: "auto" }}>
                {allEventTypeOptions && <Form>
                    <Form.Control
                        as="select"
                        value={favEventTypeChosen}
                        onChange={(e) => { setFavEventTypeChosen(e.target.value); setSearchQuery("") }}
                    >
                        <option value="workout"> Workout </option>
                        <option value="nutrition"> Nutrition </option>
                        <option value="task"> Task </option>
                    </Form.Control>
                </Form>}

                <Form.Control
                    className="mt-2"
                    placeholder={`Search ${capitalize(favEventTypeChosen)}`}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)} />

                {loadingFavoriteEvents ?
                    <Spinner animation="border" className="mt-3" variant="primary" /> :
                    <div className="mt-3">
                        <div
                            style={{ borderBottom: `2px solid ${eventColor}`, float: "left" }}
                            className="pb-1">
                            <b> {capitalize(favEventTypeChosen)} Title  </b>
                        </div>
                        <div
                            style={{ borderBottom: `2px solid ${eventColor}`, float: "right" }}
                            className="pb-1">
                            <b> Add {capitalize(favEventTypeChosen)} </b>
                        </div>
                        <div
                            style={{ clear: "both" }}
                            className="mb-3">
                        </div>

                        {chosenEventList.length > 0 &&
                            chosenEventList.filter(item => handleFilter(item)).map(event => {
                                return renderFavEvent(event, favEventTypeChosen)
                            })}
                    </div>}
            </Modal.Body>
        </Modal>)
}
export default FavoritesModal;